module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-11.3dd5a256.png";